// @ts-check
import SwishStatsModel from "./swish-stats-model";

export default class SwishMatchStatsModel extends SwishStatsModel {
  /**
   * @param {import('./interface').TSwishStats & {homeTeam:string,guestTeam:string}} data - raw api data
   */
  constructor(data) {
    super(data);
    /**
     * Indicator for is it home, or away team
     * @type {string}
     */
    this.team = data.t;
    /**
     * Name of the team
     * @type {string}
     */
    this.teamName = data.t === 'home' ? data.homeTeam : data.guestTeam;
    /**
     * Pre-match market ID
     * @type {number}
     */
    this.preMatchMarketId = data.mmid;
    /**
     * Flag to show the line or not
     * @type {boolean}
     */
    this.showLine = data.sln;
    /**
     * Flag to show team name or not
     */
    this.showTeamName = data.stm;
  }
}